export const column = [
    {
        label: '序号',
        prop: 'sortNum'
    },
    {
        label: '资讯名称',
        prop: 'infoName'
    },
    {
        width: 110,
        label: '资讯封面',
        prop: 'infoImg'
    },
    {
        label: '资讯导语',
        prop: 'infoIntroduce'
    },
    {
        label: '资讯状态',
        prop: 'state'
    },
    {
        width: 140,
        label: '资讯链接地址',
        prop: 'linkUrl'
    },
    {
        label: '置顶状态',
        prop: 'topFlag'
    },
    {
        label: '是否包含附件',
        prop: 'attachFlage'
    },
    {
        width: 120,
        label: '发布时间',
        prop: 'publishTime'
    },
    {
        width: 120,
        label: '下架时间',
        prop: 'offshelfTime'
    },
    {
        width: 120,
        label: '操作人',
        prop: 'insertName'
    },
];

export const tagList = [
    {
        label: '通知公告',
        value: 1
    },
    {
        label: '行业动态',
        value: 2
    },
    {
        label: '政策文件',
        value: 3
    },
    {
        label: '报名指南',
        value: 4
    },
    {
        label: '考培资源',
        value: 5
    },
    {
      label: '网络主播',
      value: 6
    },
    {
      label: '全媒体运营师',
      value: 7
    },
    {
      label: '网络信息审核员',
      value: 8
    },
    {
      label: 'AIGC视听创制师',
      value: 20
    },
    {
      label: '优秀案例展示',
      value: 9
    },
    {
      label: '党建工作',
      value: 10
    },
    {
      label: '实训直播基地',
      value: 11
    },
    {
      label: '隐藏栏目',
      value: 99
    },
];
